import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
type ModuleCarouselItem = {
  title: string;
  image: string;
  content: React.ReactNode;
};
type ModuleCarouselProps = {
  items: ModuleCarouselItem[];
};
export function ModuleCarousel({
  items
}: ModuleCarouselProps) {
  return <div data-id="element-235" data-mp="2axrkf4jedyn8">
      <div className="-mx-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" aria-label="Módulos del manual; deslizá para conocerlos" data-id="element-236" data-mp="2ay182lgyztpr">
        {items.map((item, index) => <article key={item.title} className="min-w-[86vw] snap-center overflow-hidden rounded-2xl border border-zinc-800 bg-zinc-900 shadow-2xl sm:min-w-[360px] md:min-w-[420px]" data-id="element-237" data-mp="2kpox6fq20yo2" data-mpi={index}>
            <div className="relative aspect-[4/5] overflow-hidden bg-black" data-id="element-238" data-mp="149cjl3shhktk">
              <img src={item.image} alt={`Preview de ${item.title}`} className="h-full w-full object-cover object-top" data-id="element-239" data-mp="14bf7nia2t3vn" />
              <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black via-black/40 to-transparent" data-id="element-240" data-mp="2qu4ztgikij4a" />
              <span className="absolute left-3 top-3 rounded-full border border-[#c6ff2e]/40 bg-black/75 px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-[#c6ff2e]" data-id="element-241" data-mp="2vpk6noi5rer7">
                Módulo {index + 1} de {items.length}
              </span>
            </div>

            <div className="p-5" data-id="element-242" data-mp="39i9zabs6zhxa">
              <h3 className="font-display text-2xl font-black leading-none text-white" data-id="element-243" data-mp="39lfkhfxp9znq">
                {item.title}
              </h3>
              <details className="group mt-4 border-t border-zinc-800 pt-3" data-id="element-244" data-mp="3jgzfm04fwubf">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-bold text-[#c6ff2e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#c6ff2e] focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-900" data-id="element-245" data-mp="3og2awsumbm67">
                  Ver todo lo que incluye
                  <ChevronDownIcon className="h-4 w-4 transition-transform group-open:rotate-180" data-id="element-246" data-mp="1m13fe7mjh3zk" />
                </summary>
                <div className="mt-4 max-h-64 overflow-y-auto pr-2 text-sm leading-relaxed text-zinc-400" data-id="element-247" data-mp="1h3len4iodv2n">
                  {item.content}
                </div>
              </details>
            </div>
          </article>)}
        <div className="w-1 shrink-0" aria-hidden="true" data-id="element-248" data-mp="1r2subycvu1sx" />
      </div>
      <p className="mt-1 text-center text-xs font-medium text-zinc-500" data-id="element-249" data-mp="24z6b159ldz6c">
        Deslizá para recorrer los 7 módulos
      </p>
    </div>;
}